import { Provider } from "@angular/core";
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef } from "@angular/material/dialog";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";

export const snackBarOptions: Provider = {
  provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
  useValue: { duration: 5000, panelClass: 'vertical-view', verticalPosition: 'top' }
}

export const dialogOptions: Provider = {
  provide: MAT_DIALOG_DEFAULT_OPTIONS,
  useValue: {}
}

export const dialogOptionsData: Provider = {
  provide: MAT_DIALOG_DATA,
  useValue: {}
}

export const dialogOptionsRef: Provider = {
  provide: MatDialogRef,
  useValue: {}
}
